import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, message, Modal, Spin, Upload } from "antd";
import { v4 as uuid } from "uuid";
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const UploadImagesButton = ({
  onDataReceived,
  setImagesList,
  isModalOpen,
  fileList,
  setFileList,
}) => {
  const [loading, setLoading] = useState(false);

  const handleChange = (values) => {
    if (values.file.status === "uploading") {
      setLoading(true);
    }
    if (values.file.status === "done") {
      onDataReceived(values.file.response.files[0].url);
      setLoading(false);
    }
  };

  return (
    <>
      <Upload
        name="file"
        action="https://deliziora-api.azurewebsites.net/menu/add-image"
        onChange={handleChange}
        maxCount={1}
        accept=".png , .jpg"
        showUploadList={false}
      >
        <ConfigProvider
          theme={{
            components: {
              Button: {
                colorPrimary: "black",
                colorPrimaryHover: "rgba(243, 101, 39, 1)",
              },
            },
          }}
        >
          <Button className="button-border">
            {loading ? (
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "rgba(243, 101, 39, 1)",
                  },
                }}
              >
                <Spin style={{ marginRight: "5px" }} />
              </ConfigProvider>
            ) : (
              ""
            )}{" "}
            Mudar de Foto
          </Button>
        </ConfigProvider>
      </Upload>
    </>
  );
};
export default UploadImagesButton;
